import { Tag } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const UnassignedResourceTag = () => (
    <Tag variant="danger">
        <LocalizedText textKey={TextKey.Unassigned} data-test-id="unassigned" />
    </Tag>
);
